"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _login = require("@/api/login");

var _auth = require("@/utils/auth");

var _moment = _interopRequireDefault(require("moment"));

var _elementUi = _interopRequireDefault(require("element-ui"));

var _panel = _interopRequireDefault(require("@/api/panel"));

var user = {
  state: {
    panelVisible: false,
    panelType: "OB",
    //OB呼出，IB呼入 
    panelTitle: '',
    ticketType: 0,
    customerPhone: "",
    customer: {},
    //客户信息
    customerId: "",
    campaignId: "",
    paperId: '',
    //任务管理的问卷
    builtId: "",
    //电访任务id
    built: '',
    //当前拨打任务 
    builtReload: "",
    //用来监控是否需要刷新builtlist
    builtManualCall: false,
    //是否从明细中手动拨打 如果是 当保存电访后 不自动触发
    callId: 0,
    //电访记录列表页 新增工单时 传递此参数 
    startTime: "",
    //开始处理电访任务时 赋值当前时间 保存电访任务时 传递此参数 
    calllogList: [],
    //通话列表 
    ticketList: [],
    //工单列表
    tickets: [],
    //选中的关联工单  
    //一些均是缓存的维表数据
    ticketConsults: [],
    //咨询项
    ticketComplains: [],
    //投诉项
    consultsNofity: [],
    //需要弹屏提醒的咨询项
    regions: [],
    //省市区
    channels: [],
    //渠道
    interests: [],
    //客户兴趣
    buyChannels: [],
    //购买渠道
    products: [],
    //商品
    productsOther: [],
    //产品中的其他项
    baseDatas: [],
    //基础配置信息
    ticketResults: [],
    //工单处理结果
    callOutResults: [] //ob电访结果

  },
  mutations: {
    togglePanel: function togglePanel(state, payload) {
      //console.log(state);
      state.panelVisible = !state.panelVisible;
    },
    updatePanel: function updatePanel(state, value) {
      state.panelVisible = value;
    },
    builtReload: function builtReload(state, value) {
      //每次电访完成保存后 更新此值（随机值）监控值 用来刷新built
      state.builtReload = value;
    },
    showPanel: function showPanel(state, payload) {
      console.info('showPanel'); //state.panelVisible = true;

      state.panelType = payload.panelType;
      state.panelTitle = payload.panelTitle;
      state.customerPhone = payload.phone;
      state.builtId = payload.builtId;
      state.built = payload.built;
      state.builtManualCall = payload.builtManualCall;
      state.callId = payload.callId;
      state.startTime = payload.startTime;
      state.ticketType = payload.ticketType;
      state.campaignId = payload.campaignId;
      state.paperId = payload.paperId;
      state.customerId = payload.customerId;
    },
    setCallId: function setCallId(state, payload) {
      state.callId = payload.callId;
    },
    customerInfo: function customerInfo(state, payload) {
      state.customer = payload.user;
      state.customerPhone = payload.user.mobile;
      state.callList = payload.jzCalllogs;
      state.calllogList = payload.jzCalllogRecords;
      state.ticketList = payload.ticketList;
      state.tickets = [];
    },
    setBaseData: function setBaseData(state, payload) {
      state.regions = payload.regions;
      state.channels = payload.channels;
      state.products = payload.products;
      state.productsOther = payload.productsOther;
      state.baseDatas = payload.baseDatas;
      state.ticketConsults = payload.consults;
      state.ticketComplains = payload.complains;
      state.ticketResults = payload.ticketResults;
      state.consultsNofity = payload.consultsNofity;
      state.callOutResults = payload.callOutResults;
    }
  },
  actions: {
    BASE_DATA: function BASE_DATA(_ref, payload) {
      var commit = _ref.commit;

      _panel.default.getBaseData(payload).then(function (res) {
        localStorage.setItem('BASE_DATA', JSON.stringify(res.data.data));
        commit("setBaseData", res.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    CUSTOMER_DETAIL: function CUSTOMER_DETAIL(_ref2, payload) {
      var commit = _ref2.commit;

      //console.log(payload);
      _panel.default.customerDetail(payload).then(function (res) {
        commit("customerInfo", res.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    START_CALL_OUT: function START_CALL_OUT(_ref3, payload) {
      var commit = _ref3.commit;

      _panel.default.getBuiltCallOut(payload).then(function (res) {
        var built = res.data.data.bulit;
        var paperId = res.data.data.paperId;
        console.info(built);
        commit("showPanel", {
          customerId: built.customerId,
          panelType: "OB",
          panelTitle: '客户' + built.callMobile + (built.contactTimes == 0 ? '--首访' : '--N访'),
          builtId: built.id,
          built: built,
          builtManualCall: payload.builtId ? true : false,
          startTime: (0, _moment.default)(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          ticketType: 0,
          campaignId: built.campaignId,
          paperId: paperId
        }); //开始ob任务-外呼

        cicGlobal.startOBTask();
      }).catch(function (err) {
        if (err.data && err.data.errmsg) _elementUi.default.Notification({
          message: err.data.errmsg,
          type: 'error',
          customClass: 'notify-on-top'
        });else _elementUi.default.Notification({
          message: '无法获取待拨打资料',
          type: 'error',
          customClass: 'notify-on-top'
        });
      });
    }
  }
};
var _default = user;
exports.default = _default;